module.exports = __webpack_public_path__ + "static/media/group_2.e322a461.jpg";